import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import { createVue2Router, installVue2Router } from './router'
import { createVue2Store, installVue2Store } from './store'
import '@mdi/font/css/materialdesignicons.css'
import './assets/scss/app.scss'
import { installVue2GlobalProperties } from './plugins/globalProperties'
import { createVue2I18n, installVue2I18n } from './plugins/i18n'
import { configureHttpStatusHandler } from './plugins/httpStatus'
import { configureValidation } from './plugins/validation'
import { installVue2Plugins } from './plugins/vue2Plugins'

Vue.config.productionTip = false

installVue2Store()
const store = createVue2Store()

installVue2Router()
const router = createVue2Router(store)

installVue2I18n()
configureValidation(Vue)
installVue2GlobalProperties(Vue)
installVue2Plugins(Vue, router, store)
configureHttpStatusHandler(store)

const i18n = createVue2I18n()

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
